import React, { useEffect } from 'react';
import { getCookie } from 'stash/utils';
import { datadogRum } from '@datadog/browser-rum';
import { WEB_APP_PATH } from 'stash/constants';
import { useIsInExperimentVariation, EXPERIMENTS } from 'stash/components/experiments';
import { v1_Experiment_Viewed } from '@stashinvest/product-events-javascript';
import { useTrack } from 'stash/hooks/useTrack';
import { getUTMCookies, setCookie } from 'stash/utils/cookies';
import { isIOS, transformURLToOpenInNativeBrowser } from 'stash/utils/mobile';

const BustingWebView = () => {
	const track = useTrack();
	const isBustingWebviewsEnabled = useIsInExperimentVariation(
		EXPERIMENTS.IS_BUSTING_WEBVIEWS_ENABLED,
		true
	);
	if (isIOS()) {
		setCookie('hasSeenWelcomeCarousel', 'true');
	}

	useEffect(() => {
		if (isBustingWebviewsEnabled) {
			// This is a timeout to ensure that Segment's anonymous id is set
			setTimeout(() => {
				/**
				 * The below snippet is required for the sending web-reg (browser)
				 * It looks at the marketing cookies and converts to query params
				 * It also adds Segment's anonymous id to the query params
				 */
				const utmCookiesString = getUTMCookies();
				const segmentId = getCookie('ajs_anonymous_id');
				const cookiesStringWithSegmentId =
					utmCookiesString +
					`${segmentId ? `&segment_id=${segmentId}` : ''}&originated=paid_social`;
				/**-------------------------------------------------------------- */

				const transformedUrl = transformURLToOpenInNativeBrowser(
					`${WEB_APP_PATH}/sign-up/get-started${
						cookiesStringWithSegmentId.length > 0 ? `?${cookiesStringWithSegmentId}` : ''
					}`
				);
				datadogRum.addAction('web-reg custom redirect', {
					url: transformedUrl,
					ldFlagValue: isBustingWebviewsEnabled,
				});
				track(
					v1_Experiment_Viewed({
						experiment: EXPERIMENTS.IS_BUSTING_WEBVIEWS_ENABLED,
						variant: 'true',
					})
				);
				window.location.replace(transformedUrl);
			}, 500);
		} else {
			datadogRum.addAction('web-reg custom redirect', {
				ldFlagValue: isBustingWebviewsEnabled,
			});
			track(
				v1_Experiment_Viewed({
					experiment: EXPERIMENTS.IS_BUSTING_WEBVIEWS_ENABLED,
					variant: 'false',
				})
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <></>;
};

export default BustingWebView;
